import { createAction } from '@reduxjs/toolkit';

export const wishListToggleAction = createAction<boolean>('wishListToggle');
